import React, { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";

import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import CurrencyPoundOutlinedIcon from "@mui/icons-material/CurrencyPoundOutlined";
import GppGoodOutlinedIcon from "@mui/icons-material/GppGoodOutlined";
import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import Header from "../components/NewUi/Header/LoginHeader";

import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import PrivacyPolicyModal from "./privacyPolicy/PrivacyPolicyModal";
import SaasModal from "./privacyPolicy/SaasModel";
import EulaModal from "./privacyPolicy/eulaModal";

import styles from "./Login.module.scss";

export default function Login() {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showSAASModal, setShowSAASModal] = useState(false);
  const [showEulaModal, setShowEulaModal] = useState(false);

  const [privacyContent, setPrivacyContent] = useState("");
  const [saasContent, setSaasContent] = useState("");
  const [eulaContent, setEulaContent] = useState("");

  const [hasGuestRef, setHasGuestRef] = useState(false);

  const [email, setEmail] = useState("you@practice.com");
  const [password, setPassword] = useState("password");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const guestRef = params.get("guest_purchase_reference");
    setHasGuestRef(Boolean(guestRef));

    if (guestRef) {
      localStorage.setItem("guest_purchase_reference", guestRef);
    }
  }, []);

  const loadDoc = async (id, setter, modalSetter) => {
    try {
      const mockDocs = {
        1: "EULA content goes here.",
        2: "Terms of Service content goes here.",
        3: "Privacy Policy content goes here.",
      };

      setter(mockDocs[id] || "Document not found.");
    } catch (error) {
      setter("Failed to load document.");
    } finally {
      modalSetter(true);
    }
  };

  const loginDentally = useMutation({
    mutationFn: () =>
      axios.get("/auth/get_dentally_request_auth_link?capture=default"),
    onSuccess: (res) => {
      window.location.replace(res.data);
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handleGoogleLogin = () => {};

  return (
    <div className={styles.page}>
       <Header />
      <div className={styles.bgOrb1} />
      <div className={styles.bgOrb2} />
      <div className={styles.bgOrb3} />
      <div className={styles.bgOrb4} />
      <div className={styles.bgOrb5} />

      

      <main className={styles.main}>
        <div className={styles.contentShell}>
          <section className={styles.leftPanel}>
            <div className={styles.leftInner}>
              <h1 className={styles.heroTitle}>
                Stop Losing High Value Cases to Poor Consent Workflows
              </h1>

              <p className={styles.heroSubtitle}>
                Send 3 AI-personalised consent packs a day. Watch case acceptance
                double. Your patients finally understand,and say yes.
              </p>

              <div className={styles.visualCard}>
                <img
                  src="/tooth.gif"
                  alt="Dental model"
                  className={styles.visualImage}
                />
              </div>

              <div className={styles.featureList}>
                <div className={styles.featureItem}>
                  <div className={styles.featureIcon}>
                    <GppGoodOutlinedIcon />
                  </div>
                  <span>AI writes your consent forms in seconds not hours</span>
                </div>

                <div className={styles.featureItem}>
                  <div className={styles.featureIcon}>
                    <BoltOutlinedIcon />
                  </div>
                  <span>
                    Patients see exactly what you see,3D visuals they actually
                    understand
                  </span>
                </div>

                <div className={styles.featureItem}>
                  <div className={styles.featureIcon}>
                    <ShieldOutlinedIcon />
                  </div>
                  <span>One-click Dentally sync zero double entry</span>
                </div>
              </div>

              <div className={styles.statsRow}>
                <div className={styles.statCard}>
                  <div className={styles.statIcon}>
                    <AccessTimeOutlinedIcon />
                  </div>
                  <div className={styles.statValue}>20 min</div>
                  <div className={styles.statLabel}>Setup Time</div>
                </div>

                <div className={styles.statCard}>
                  <div className={styles.statIcon}>
                    <TrendingUpOutlinedIcon />
                  </div>
                  <div className={styles.statValue}>2x</div>
                  <div className={styles.statLabel}>Case Acceptance</div>
                </div>

                <div className={styles.statCard}>
                  <div className={styles.statIcon}>
                    <CurrencyPoundOutlinedIcon />
                  </div>
                  <div className={styles.statValue}>10x</div>
                  <div className={styles.statLabel}>ROI on Investment</div>
                </div>
              </div>

              <div className={styles.badgesRow}>
                <div className={styles.badgePill}>
                  <ShieldOutlinedIcon />
                  <span>Following GDC Standards</span>
                </div>

                <div className={styles.badgePill}>
                  <GppGoodOutlinedIcon />
                  <span>GDPR Compliant</span>
                </div>

                <div className={styles.badgePill}>
                  <LockOutlinedIcon />
                  <span>Encrypted &amp; Secure</span>
                </div>
              </div>
            </div>
          </section>

          <section className={styles.rightPanel}>
            <div className={styles.rightInner}>
              <div className={styles.loginCard}>
                <div className={styles.loginHeader}>
                  <h2>Sign In</h2>
                  <p>Your patients are waiting for clarity</p>
                </div>

                <div className={styles.miniBrand}>
                  {/* <img src="/logo.png" alt="Medicube" className={styles.miniLogo} /> */}
                </div>

                {hasGuestRef && (
                  <div className={styles.alertWrap}>
                    <Alert
                      severity="warning"
                      variant="outlined"
                      sx={{
                        borderRadius: 14,
                        borderWidth: 1.5,
                        px: 2,
                        py: 1.2,
                        "& .MuiAlertTitle-root": { fontWeight: 800, mb: 0.5 },
                      }}
                    >
                      <AlertTitle>Important notice</AlertTitle>
                      When you connect to Dentally via Medicube for the first
                      time, Dentally may show a standard warning related to
                      third-party access and data security. Read our{" "}
                      <span
                        className={styles.inlineLink}
                        onClick={() =>
                          loadDoc(3, setPrivacyContent, setShowPrivacyModal)
                        }
                        role="button"
                        tabIndex={0}
                      >
                        Privacy Policy
                      </span>
                      .
                    </Alert>
                  </div>
                )}

                <Button
                  className={styles.dentallyButton}
                  onClick={() => loginDentally.mutate()}
                  disabled={loginDentally.isPending}
                >
                  <img
                    src="/dentally-Photoroom.png"
                    alt="Dentally"
                    className={styles.dentallyLogo}
                  />
                  <span>
                    {loginDentally.isPending
                      ? "Redirecting..."
                      : "Sign In with Dentally SSO"}
                  </span>
                </Button>

                <div className={styles.recommendedText}>
                  Recommended — Single Sign-On via Dentally
                </div>

                {/* <button
                  type="button"
                  className={styles.googleButton}
                  onClick={handleGoogleLogin}
                >
                  <img
                    src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                    alt="Google"
                  />
                  <span>Sign in with Google</span>
                </button> */}

                <div className={styles.dividerWrap}>
                  <span className={styles.dividerLine} />
                  {/* <span className={styles.dividerText}>OR</span> */}
                  <span className={styles.dividerLine} />
                </div>

                {/* <form className={styles.form} onSubmit={handleSubmit}>
                  <div className={styles.fieldBlock}>
                    <label>Email</label>
                    <TextField
                      fullWidth
                      placeholder="you@practice.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      variant="outlined"
                      className={styles.inputField}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <EmailOutlinedIcon className={styles.inputIcon} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>

                  <div className={styles.passwordLabelRow}>
                    <label>Password</label>
                    <button type="button" className={styles.forgotBtn}>
                      Forgot password?
                    </button>
                  </div>

                  <div className={styles.fieldBlock}>
                    <TextField
                      fullWidth
                      placeholder="••••••••"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      type={showPassword ? "text" : "password"}
                      variant="outlined"
                      className={styles.inputField}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <LockOutlinedIcon className={styles.inputIcon} />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword((prev) => !prev)}
                              edge="end"
                            >
                              {showPassword ? (
                                <VisibilityOffOutlinedIcon className={styles.inputIcon} />
                              ) : (
                                <VisibilityOutlinedIcon className={styles.inputIcon} />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>

                  <Button type="submit" fullWidth className={styles.signInButton}>
                    Sign In
                  </Button>
                </form> */}
              {/* 
                <div className={styles.signUpText}>
                  New user? <span>Sign Up</span>
                </div> */}
              </div>

              <div className={styles.loginFooter}>
                By signing in, you agree to our{" "}
                <span onClick={() => loadDoc(2, setSaasContent, setShowSAASModal)}>
                  Terms of Service
                </span>{" "}
                and{" "}
                <span
                  onClick={() =>
                    loadDoc(3, setPrivacyContent, setShowPrivacyModal)
                  }
                >
                  Privacy Policy
                </span>
                <br />© 2026 Medicube Health — Smart Consent Platform
              </div>
            </div>
          </section>
        </div>
      </main>

      <PrivacyPolicyModal
        open={showPrivacyModal}
        onClose={() => setShowPrivacyModal(false)}
        content={privacyContent}
      />

      <SaasModal
        open={showSAASModal}
        onClose={() => setShowSAASModal(false)}
        content={saasContent}
      />

      <EulaModal
        open={showEulaModal}
        onClose={() => setShowEulaModal(false)}
        content={eulaContent}
      />
    </div>
  );
}